
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import FormLayout from '@/components/layouts/FormLayout';
import Login from '@/components/login/Login';
import { NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import Head from 'next/head';
import React from 'react';
const LoginPage: NextPage = () => {
    const { t } = useTranslation();
    return (<FormLayout>
			<Head>
				<title>constrAction - {t('common:login')}</title>
			</Head>
			<Login />
		</FormLayout>);
};
export default LoginPage;

    async function __Next_Translate__getStaticProps__19720e241b7__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/login',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19720e241b7__ as getStaticProps }
  